export default __webpack_public_path__ + "static/media/Confident-menu-traingle.de9da5ac.svg";